export const UAE = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_11011_8977)">
                <path
                    d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
                    fill="white"
                />
                <path
                    d="M5.65234 13.4775L6.52191 19.3774C7.6052 19.7794 8.77695 19.9993 10.0002 19.9993C14.2998 19.9993 17.9652 17.2855 19.3781 13.4775H5.65234Z"
                    fill="black"
                />
                <path
                    d="M5.65234 6.52225L6.52191 0.622402C7.6052 0.22041 8.77695 0.000488281 10.0002 0.000488281C14.2998 0.000488281 17.9652 2.71424 19.3781 6.52225H5.65234Z"
                    fill="#6DA544"
                />
                <path
                    d="M0 10.0001C0 14.2997 2.71379 17.9652 6.52176 19.3781V0.62207C2.71379 2.035 0 5.70043 0 10.0001Z"
                    fill="#A2001D"
                />
            </g>
            <path
                d="M0.5 10C0.5 4.7533 4.7533 0.5 10 0.5C15.2467 0.5 19.5 4.7533 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5C4.7533 19.5 0.5 15.2467 0.5 10Z"
                stroke="white"
            />
            <defs>
                <clipPath id="clip0_11011_8977">
                    <path
                        d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}
